import { OktaAuthOptions } from '@okta/okta-auth-js';
import { environment } from 'src/environments/environment';

export class OktaConfigProvider {
  private static _issuer = environment.issuer;
  private static _clientId = environment.clientId;

  public static get issuer(): string {
    return this._issuer;
  }

  public static get clientId(): string {
    return this._clientId;
  }

  static getConfig(): OktaAuthOptions {
    return {
      issuer: this.issuer,
      clientId: this.clientId,
      redirectUri: this.getOrigin(),
      postLogoutRedirectUri: this.getOrigin(),
      scopes: ['openid', 'profile', 'email', 'offline_access'] // Add this line
    };
  }

  static setConfig(issuer: string, clientId: string) {
    this._issuer = issuer;
    this._clientId = clientId;
  }

  static getOrigin(): string {
    return window.location.origin;
  }

}
